/** @jsx h */
import { createImageUrl } from '@nrk/serum-imagecrop-utils';
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';

class SerumImage extends PureComponent {
  render() {
    const _this$props = this.props,
          className = _this$props.className,
          alt = _this$props.alt,
          id = _this$props.id,
          quality = _this$props.quality,
          ratio = _this$props.ratio,
          width = _this$props.width;
    const src = createImageUrl({
      id,
      width,
      quality,
      ratio
    });
    return h("img", {
      className: className,
      src: src,
      alt: alt
    });
  }

}

export default SerumImage;